import { Link } from "react-router-dom";
import { Package, Clock, Layers, Wallet } from "lucide-react";

export default function WalletStrip({ pkg }) {
  if (!pkg) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-md p-3 flex items-center justify-between mb-4" data-testid="wallet-no-package">
        <div className="flex items-center gap-3">
          <Wallet className="w-5 h-5 text-amber-600" />
          <div>
            <p className="text-sm font-semibold text-amber-900">No active package</p>
            <p className="text-xs text-amber-700">Grab the Trial (free) or purchase a plan to unlock the toolbox.</p>
          </div>
        </div>
        <Link to="/pricing" data-testid="wallet-buy-link" className="bg-sage-600 text-white text-xs font-semibold rounded-md px-3 py-2 hover:bg-sage-700">View plans</Link>
      </div>
    );
  }
  const usedPct = pkg.slots_total > 0 ? Math.round((pkg.slots_used / pkg.slots_total) * 100) : 0;
  const expires = new Date(pkg.expires_at);
  const daysLeft = Math.max(0, Math.ceil((expires - new Date()) / 86400000));
  const isLow = pkg.slots_remaining <= 1 || daysLeft < 15;
  return (
    <div className="bg-white border border-[#E2E8E3] rounded-md p-4 mb-4 grid grid-cols-1 md:grid-cols-4 gap-4" data-testid="wallet-strip">
      <div>
        <p className="text-xs uppercase tracking-wider text-sage-500 font-semibold mb-0.5">Plan</p>
        <p className="font-heading text-base font-semibold text-sage-900 capitalize">{pkg.tier}</p>
        <p className="text-xs text-sage-400">{pkg.branding_allowed ? "Whitelabel enabled" : "Branding locked"}</p>
      </div>
      <div>
        <p className="text-xs uppercase tracking-wider text-sage-500 font-semibold mb-0.5 flex items-center gap-1"><Package className="w-3 h-3" /> Company slots</p>
        <p className="font-heading text-base font-semibold text-sage-900">{pkg.slots_used} / {pkg.slots_total}</p>
        <div className="mt-1 h-1.5 bg-sage-100 rounded-full overflow-hidden">
          <div className={`h-full ${usedPct > 80 ? "bg-amber-500" : "bg-sage-500"}`} style={{ width: `${usedPct}%` }} />
        </div>
      </div>
      <div>
        <p className="text-xs uppercase tracking-wider text-sage-500 font-semibold mb-0.5 flex items-center gap-1"><Layers className="w-3 h-3" /> Tools unlocked</p>
        <p className="font-heading text-base font-semibold text-sage-900">{pkg.tools_enabled.length}</p>
        <Link to="/catalogue" className="text-xs text-sage-600 hover:underline">View catalogue</Link>
      </div>
      <div>
        <p className="text-xs uppercase tracking-wider text-sage-500 font-semibold mb-0.5 flex items-center gap-1"><Clock className="w-3 h-3" /> Expires</p>
        <p className={`font-heading text-base font-semibold ${isLow ? "text-amber-600" : "text-sage-900"}`}>{daysLeft}d <span className="text-xs font-normal text-sage-400">({expires.toLocaleDateString()})</span></p>
        {(isLow || pkg.slots_remaining === 0) && (
          <Link to="/pricing" className="text-xs text-sage-600 hover:underline font-semibold">Upgrade →</Link>
        )}
      </div>
    </div>
  );
}
